module.exports = __webpack_public_path__ + "img/man-walking-dog.0243149.svg";